import { Cron } from '../services/cron';
import { Invitation } from './invitation';

export class Group {
    id: string;
    name: string;
    rules: string;
    share: number;
    startDate: Date;
    meetups: string;
    members: any[];
    invitations: Invitation[];
    private cron: Cron;

    constructor(res: any) {
        if (res == null) return;
        this.id = res.id;
        this.name = res.name;
        this.rules = res.rules;
        this.share = res.share;
        this.startDate = res.startDate;
        this.meetups = res.meetups;
        this.members = res.users;
        this.cron = Cron.parse(res.meetups);
    }
    totalPot() {
        return (this.share) ? this.share * this.totalMembers() : 0;
    }
    totalMembers() {
        return (this.members) ? Object.keys(this.members).length : 0;
    }
    getEndDate() {
        if (!this.startDate) return;
        var endDate = new Date(this.startDate);
        endDate.setMonth(endDate.getMonth() + this.totalMembers() -1 );
        return endDate;
    }
    getNextMeetup() {
        if (!this.cron) return;
        return this.cron.getNextDate();
    }
}

export class User {
    id: string;
    name: string;
    email: string;
    emailVerified: boolean;
    provider: string;
    groups: string[];

    constructor(res: any) {
        if (res == null) return;
        this.id = res.id;
        this.name = res.name;
        this.email = res.email;
        this.emailVerified = res.emailVerified;
        this.provider = res.provider;
        this.groups = res.groups;
    }
}